import {
  clearLocalSessionToken,
  decodeLocalSession,
  getLocalSessionToken,
} from '../api/authToken';
import { clearImpersonationSession } from '../impersonation/utils/impersonationSession';

const listeners = new Set();

function sessionUser() {
  const token = getLocalSessionToken();
  const payload = decodeLocalSession(token);
  if (!payload || payload.kind === 'admin' || payload.kind === 'client') return null;
  return {
    uid: payload.uid,
    email: payload.email || null,
    providerData: [{ providerId: 'password' }],
    getIdToken: async () => getLocalSessionToken(),
    getIdTokenResult: async () => ({
      claims: {
        impersonating: Boolean(payload.impersonatorAdminId),
        impersonatedBy: payload.impersonatorAdminId || null,
      },
    }),
  };
}

function notify(user) {
  listeners.forEach((cb) => {
    try {
      cb(user);
    } catch {
      // ignore
    }
  });
}

export function notifyStaffAuthChanged() {
  notify(sessionUser());
}

export const auth = {
  get currentUser() {
    return sessionUser();
  },
  onAuthStateChanged(cb) {
    return onAuthStateChanged(auth, cb);
  },
  async signOut() {
    clearLocalSessionToken();
    clearImpersonationSession();
    notify(null);
  },
};

export { auth as mainAuth };
export const app = { name: 'app' };
export const actionCodeSettings = {};
export const passwordResetSettings = {};
export const emailRecoverySettings = {};
export function sendVerificationEmail() {
  return Promise.resolve();
}

export function onAuthStateChanged(_auth, cb) {
  cb(sessionUser());
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export async function signOut(authInstance = auth) {
  await authInstance.signOut();
}
